module.exports = __webpack_public_path__ + "img/03d.6d122f79.jpg";